export const InfoIcon = ({
  width = 15,
  height = 15,
  primaryColor = '#ffd800',
  primaryFontColor = '#3b4046',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
    >
      <g
        id="Group_42262"
        data-name="Group 42262"
        transform="translate(-11784.031 -10689)"
      >
        <path
          id="Path_64755"
          data-name="Path 64755"
          d="M11.031,0a6,6,0,1,0,6,6,6,6,0,0,0-6-6m.616,8.382c0,.19-.276.379-.616.379-.355,0-.608-.19-.608-.379V5.373c0-.221.253-.373.608-.373.34,0,.616.15.616.371Zm-.616-4.107a.618.618,0,0,1-.648-.569.65.65,0,0,1,1.288,0,.616.616,0,0,1-.64.569"
          transform="translate(11779 10689)"
          fill={primaryColor}
        />
        <g
          id="Group_42261"
          data-name="Group 42261"
          transform="translate(-19.613 -5.664)"
        >
          <path
            id="Path_64756"
            data-name="Path 64756"
            d="M.648,4.712c-.355,0-.608.153-.608.376V8.126c0,.191.253.383.608.383.34,0,.616-.191.616-.383V5.086c0-.223-.276-.374-.616-.374"
            transform="translate(11809 10694.965)"
            fill={primaryFontColor}
          />
          <path
            id="Path_64757"
            data-name="Path 64757"
            d="M.693,2.857a.655.655,0,0,0-.693.6.662.662,0,0,0,.693.609.659.659,0,0,0,.685-.609.652.652,0,0,0-.685-.6"
            transform="translate(11808.962 10694.921)"
            fill={primaryFontColor}
          />
        </g>
      </g>
    </svg>
  );
};
